import AxiosInstance from "../components/Axios"
import { HistoryNotificationProps } from "../interfaces/history"

/**
 * This gets the history and logs of anything related to the user's assigned projects.
 *      (Tasks, Submittals, RFIs, etc. etc.)
 * @returns The history of the user
 */
export async function getUserHistory(): Promise<HistoryNotificationProps[]> {
    try {
        const response = await AxiosInstance.get('api/history')
        return response.data
    } catch (error: unknown) {
        throw new Error("Error fetching history")
    }
}